export default __webpack_public_path__ + "static/media/navbar.d94ceb2e.png";